const invertedMessages = {
  Active: 'external.search.identities.active',
  Inactive: 'external.search.identities.inactive',
  'User Name': 'external.search.identities.userName',
  'First Name': 'external.search.identities.firstName',
  'Last Name': 'external.search.identities.lastName',
  Email: 'external.search.identities.email',
  Status: 'external.search.identities.status',
  'Search identities': 'external.search.identities.searchIdentities',
  'Suspended From Import Service': 'external.search.identities.status7',
  'No users found': 'external.search.identities.noUsersFound',
} as const;

export default invertedMessages;
